<div class='thongke-title'>
    <p [style.font-size]='font_size' [style.color]='colorNumber'>{{numberCount}}</p>
    <p style="font-size: 16px;">{{title}}</p>
</div>